module.exports = __webpack_public_path__ + "static/img/core-4.dc14249b.png";